var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgLoading = props => /*#__PURE__*/React.createElement("svg", _extends({
  className: "load__icon",
  fill: "#E64823",
  id: "Capa_1",
  width: "64px",
  height: "64px",
  viewBox: "0 0 26.349 26.35",
  xmlSpace: "preserve"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "SVGRepo_bgCarrier",
  strokeWidth: 0
})), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  id: "SVGRepo_tracerCarrier",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  id: "SVGRepo_iconCarrier"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  cx: 13.792,
  cy: 3.082,
  r: 3.082
}), /*#__PURE__*/React.createElement("circle", {
  cx: 13.792,
  cy: 24.501,
  r: 1.849
}), /*#__PURE__*/React.createElement("circle", {
  cx: 6.219,
  cy: 6.218,
  r: 2.774
}), /*#__PURE__*/React.createElement("circle", {
  cx: 21.365,
  cy: 21.363,
  r: 1.541
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3.082,
  cy: 13.792,
  r: 2.465
}), /*#__PURE__*/React.createElement("circle", {
  cx: 24.501,
  cy: 13.791,
  r: 1.232
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.694,19.84c-0.843,0.843-0.843,2.207,0,3.05c0.842,0.843,2.208,0.843,3.05,0c0.843-0.843,0.843-2.207,0-3.05 C6.902,18.996,5.537,18.988,4.694,19.84z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 21.364,
  cy: 6.218,
  r: 0.924
}))))));
export default __webpack_public_path__ + "static/media/loading.bfb53e9e.svg";
export { SvgLoading as ReactComponent };